<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right" style="height: 3rem;line-height: 3rem;">
		  <el-breadcrumb-item v-for="(item,index) in breadList" :to="{ path: item.path }" :key="index">{{item.meta.title}}</el-breadcrumb-item>
		</el-breadcrumb>
		<router-view />
	</div>
</template>

<script>
	export default {
		data(){
			return {
				breadList: [] // 路由集合
			}
		},
		 watch: {
		  $route() {
		   this.getBreadcrumb();
		  }
		 },
		methods: {
		  isHome(route) {
			// console.log(route)
			return route.name === "Home";
		  },
		  getBreadcrumb() {
			let matched = this.$route.matched;
			if (!this.isHome(matched)) {
				matched = [{ path: "/Home", meta: { title: "首页" } }].concat(matched);
			}
			this.breadList = matched;
			this.breadList.forEach((el,index)=>{
				if(!el.meta.title){
					this.breadList.splice(index,1)
				}
			})
			document.title = this.breadList[this.breadList.length - 1].meta.title
		  }
		 },
		 created() {
		  this.getBreadcrumb();
		 }
	}
</script>

<style>
</style>
